import { forwardRef } from 'react';
import PhoneInput from 'react-phone-input-2';

export const PhoneInputWithRef = forwardRef((props, ref) => {
  const addCountryCode = (value) => {
    if (!value?.startsWith('+1') && !value?.startsWith('1')) {
      return `+1${value}`;
    }
    return value;
  };

  const handleChange = e => {
    const { value } = e.target;

    if (value === '') {
      props.onChange('+1');
    } else {
      props.onChange(addCountryCode(value));
    }
  };

  return (
    <PhoneInput
      {...props}
      inputProps={{
        ref,
        onInput: handleChange,
        autoComplete: 'tel',
      }}
      inputStyle={{
        minHeight: '46px',
        width: '100%',
        border: '1px solid #dfdfdf',
        borderRadius: '2px',
        fontSize: '1.2rem',
        paddingLeft: '15px'
      }}
      containerClass="no-flag"
    />
  );
});
